import { Box, Typography } from '@mui/material'
import SearchRow from './SearchRow'
import ThreadListRow from './ThreadListRow'
import ThreadsSearchDialogFilters from './ThreadsSearchDialogFilters'
import { threadsSearchListEmpty } from './threadsSearchListEmpty'
import styles from './ThreadsSectionAllThreadsDialog.module.scss'

export default function ThreadsSearchDialogList({
  searchValue,
  setSearchValue,
  filter,
  setFilter,
  threads,
  hasThreads,
  loading,
  previewId,
  selectThread,
  onThreadMenuAction,
  onRenameThread,
}) {
  return (
    <div className={styles.listPane}>
      <SearchRow value={searchValue} onChange={setSearchValue} placeholder="Search threads" />
      <ThreadsSearchDialogFilters filter={filter} onChange={setFilter} />
      {threads.length === 0 ? (
        <Typography component="p" className={styles.empty}>
          {threadsSearchListEmpty({ loading, hasThreads })}
        </Typography>
      ) : (
        <Box component="ul" className={styles.list} aria-label="All threads">
          {threads.map((thread) => (
            <Box component="li" key={thread.id} className={styles.listItem}>
              <ThreadListRow
                title={thread.title}
                thread={thread}
                menuSurface="threads"
                active={thread.id === previewId}
                onClick={() => selectThread(thread)}
                onThreadMenuAction={onThreadMenuAction}
                onRenameThread={onRenameThread}
              />
            </Box>
          ))}
        </Box>
      )}
    </div>
  )
}
